import { Button, Typography } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogTitle from "@mui/material/DialogTitle";
import { useNavigate } from "react-router";

import fontWeight from "../../../styles/mui/fontWeight";
import { colors } from "../../../styles/colors";
import { confirmationDialogBox, FaCheckCircleIcon } from "../styles/style";
import { WELCOME_PAGE } from "../../../constants/ReferralPaths";
import { RequestAuthorizationDispatchTypes } from "../../../constants/RequestAuthorization";

export interface Props {
    confirmationMessageTitle: string;
    setOpenConfirmation: (value: boolean) => void;
    openConfirmation: boolean;
    resetStates: (actionType: string[]) => void;
}
const ConfirmationDialog = ({
    openConfirmation,
    setOpenConfirmation,
    confirmationMessageTitle,
    resetStates,
}: Props) => {

  const navigate = useNavigate();

  const handleClose = () => {
    setOpenConfirmation(false);
    resetStates([
      RequestAuthorizationDispatchTypes.REQUEST_AUTHORIZATION_RESET,
    ]);
    navigate(WELCOME_PAGE);
  };

  return (
    <Dialog
      open={openConfirmation}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      disableScrollLock
      sx={confirmationDialogBox}
      maxWidth={'xs'}
      fullWidth={true}
    >
      <DialogTitle id="alert-dialog-title">
        <FaCheckCircleIcon />
        <Typography
          variant="body1"
          fontSize=".85rem"
          margin={"0.5rem 0 0.5rem"}
          padding={"5px 24px"}
          fontWeight={fontWeight.Weight[6]}
          color={colors.black[11]}
        >
          {confirmationMessageTitle}
        </Typography>
      </DialogTitle>
      <DialogActions sx={{ justifyContent: "center" }}>
        <Button variant="contained" onClick={handleClose}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationDialog;
